<template>
  <vue-dialog :dialog-data="dialogData" @confirm="confirm">
    <el-form :model="form" label-width="auto" :rules="rules" ref="form" size="small">
      <el-form-item label="密码" prop="password">
        <el-input show-password v-model.trim="form.password" clearable :maxlength="32" show-word-limit></el-input>
      </el-form-item>
      <el-form-item label="确认密码" prop="repassword">
        <el-input show-password v-model.trim="form.repassword" clearable :maxlength="32" show-word-limit></el-input>
      </el-form-item>
    </el-form>
  </vue-dialog>
</template>

<script>
import {inputEmpty, checkPwd} from '@utils/validate'
export default {
  name: "TableOperate",
  props: {dialogData: Object},
  data() {
    let checkRePass = (rule, value, callback) => {
      if (value !== this.form.password) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      form: {
        password: "",
        repassword: "",
      },
      rules: {
        password: [inputEmpty("密码"), checkPwd()],
        repassword: [inputEmpty('确认密码'), {validator: checkRePass, trigger: 'blur'}],
      },
    }
  },
  methods: {
    confirm() {
      this.$refs["form"].validate(async isOk => {
        if (isOk) {
          let nv = {
            admin_id: this.dialogData.row.id,
            ...this.form
          };
          let res = await this.$Http.pwdAdmin(nv);
          if (res) {
            this.msgSuccess("重置成功");
            this.dialogData.visible = false;
          }
        }
      });
    },
  },
}
</script>

<style scoped>

</style>
